import { Text } from '@hhgtech/hhg-components/mantine'
import { BoxProps, Stack } from '@mantine/core'

import { Container } from 'components/atoms/container'
import { SpotlightCTABannerSession } from 'interfaces/types'

import { CtaBannerContext } from './context'
import useMultiStyles from './multi.styles'
import { MultipleImage } from './MultipleImage'
import useSingleStyles from './single.styles'
import { SingleImage } from './SingleImage'

type Props = {
  data: SpotlightCTABannerSession
} & BoxProps
export const CtaBannerSection = ({
  data,
  styles,
  className,
  classNames,
  ...restProps
}: Props) => {
  const { title, description, type, layout, listing, backgroundColor } = data
  const isSingleImage = type === 'single-image'
  const isMultiImage = type === 'multiple-image'
  const useStyles = isSingleImage ? useSingleStyles : useMultiStyles
  const { classes, cx } = useStyles(
    { backgroundColor },
    {
      name: 'CtaBannerSection',
      styles,
      classNames,
    },
  )
  return (
    <CtaBannerContext.Provider value={{ data }}>
      <Stack spacing={0} {...restProps} className={cx(classes.root, className)}>
        {(title || description) && (
          <Container>
            <Stack spacing={8} className={classes.header}>
              {title && (
                <Text size="h2" weight="bold">
                  {title}
                </Text>
              )}
              {description && <Text size="p2">{description}</Text>}
            </Stack>
          </Container>
        )}
        {isSingleImage ? (
          <SingleImage
            layout={layout as any}
            banner={listing?.[0]?.banners?.[0]}
            layoutPosition={data.layoutPosition}
          />
        ) : isMultiImage ? (
          <Container>
            <MultipleImage />
          </Container>
        ) : null}
      </Stack>
    </CtaBannerContext.Provider>
  )
}
